import { getQueryParams} from '@express-labs/raven-tools';
import {isHeaderEnvProduction} from '../../../constants';

function getComComQueryParams(query) {
  const queryParams = getQueryParams(query);
  const pubname = queryParams ? queryParams.pubname : '';
  const cjEvent =queryParams ? queryParams.CJEVENT : '';
  const prodPubName = pubname === 'CIQ-Express';
  const nonProdPubName = pubname === 'Commission+Junction';
  const isProd = isHeaderEnvProduction();
  const isProdCJComComComURL = isProd && prodPubName;
  const isNonProdCJComComURL = !isProd && nonProdPubName;
  const isComComPN = isProdCJComComComURL || isNonProdCJComComURL;

  let sellerId = '';

  if (isComComPN) {
    sellerId = queryParams ? queryParams.PID : '';
  }

  return { sellerId, cjEvent, isComComPN };
}

export default getComComQueryParams;
